import {
	AfterContentChecked,
	ChangeDetectorRef,
	Component,
	Inject,
	OnDestroy,
	OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Client } from 'projects/access-control/src/app/Domain/Entities/client.interface';
import { Groups } from 'projects/access-control/src/app/Domain/Entities/group.interface';
import { getClient } from 'projects/access-control/src/app/Infrastructure/Store/clients/clients.action';
import { selectClientState } from 'projects/access-control/src/app/Infrastructure/Store/clients/clients.selectors';
import {
	postGroup,
	updateGroup,
	updateSelectedGroup,
} from 'projects/access-control/src/app/Infrastructure/Store/groups/groups.action';
import { TranslateService } from '@mangosoft/mango-layout';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
interface translateModalGroup {
	nameGroup: string;
	nameSubGroup: string;
	nameUpdate: string;
	upload: string;
	name: string;
	placeholderName: string;
	nameRequired: string;
	email: string;
	placeholderEmail: string;
	emailRequired: string;
	client: string;
	placeholderClient: string;
	buttonSave: string;
	buttonCancel: string;
}
@Component({
	selector: 'app-modal-new-group',
	templateUrl: './modal-new-group.component.html',
	styleUrls: ['./modal-new-group.component.scss'],
})
export class ModalNewGroupComponent implements OnInit, OnDestroy, AfterContentChecked {
	title = '';
	formGroup!: FormGroup;
	clients: Client[] = [];
	subscriptionClient!: Subscription;
	fileUrl: string = '';
	translateModal: translateModalGroup = {} as translateModalGroup;
	subscriptionTranslate!: Subscription;

	constructor(
		private store: Store,
		private formBuilder: FormBuilder,
		public dialogRef: MatDialogRef<ModalNewGroupComponent>,
		private changeDetector: ChangeDetectorRef,
		private translate: TranslateService,
		@Inject(MAT_DIALOG_DATA) public data: { type: string; group: Groups }
	) {}

	ngOnInit(): void {
		this.infoInitModalGroup();
		this.fileUrl = this.data.group.picture || '';
	}

	infoInitModalGroup() {
		this.formGroup = this.formBuilder.group({
			name: ['', [Validators.required]],
			emailTemplade: ['', []],
			client: [this.data.group.clientName, [Validators.required]],
		});
		setTimeout(() => {
			this.dataTranslate();
			if (this.data.type.includes('update')) {
				this.formGroup.patchValue({
					...this.data.group,
				});
			}
			if (
				this.data.type === 'newGroups' ||
				this.data.type === 'updateSelectedGroup' ||
				this.data.type === 'updateGroup'
			) {
				this.store.dispatch(getClient());
				this.getClients();
			}
		});
	}
	get f() {
		return this.formGroup.controls;
	}
	save() {
		//Falta la opcion del archivo cuando se tenga listo el backend
		if (this.formGroup.valid) {
			const { client, ...dataGroups } = this.formGroup.value;
			let group: Groups = {
				...dataGroups,
				picture: this.fileUrl,
			};
			if (this.data.type == 'newGroups') {
				group.client = this.formGroup.value?.client?.sk || '';
			}
			if (this.data.type === 'newSubGroups') {
				group.parentSk = this.data.group.sk;
			}

			if (this.data.type === 'updateGroup' || this.data.type === 'updateSubGroup') {
				this.store.dispatch(
					updateGroup({ group, ids: { pk: this.data.group.pk, sk: this.data.group.sk } })
				);
			} else if (
				this.data.type === 'updateSelectedGroup' ||
				this.data.type === 'updateSelectedSubGroup'
			) {
				this.store.dispatch(
					updateSelectedGroup({ group, ids: { pk: this.data.group.pk, sk: this.data.group.sk } })
				);
			} else {
				this.store.dispatch(postGroup({ group }));
			}
			this.dialogRef.close();
		}
	}
	urlUploadedHandle(event: any) {
		this.fileUrl = event.url;
	}

	urlUploadedErrorHandle(event: any) {
		console.error(event);
	}

	getClients() {
		this.subscriptionClient = this.store
			.pipe(select(selectClientState))
			.subscribe(({ clients }) => {
				this.clients = clients;
				if (
					this.data.type === 'updateGroup' ||
					this.data.type === 'newSubGroups' ||
					this.data.type === 'updateSelectedGroup'
				) {
					const client = this.clients.find((clientId) =>
						clientId.sk.includes(this.data.group.client)
					) as Client;
					this.formGroup.controls['client'].setValue(client);
				}
				if (this.data.type !== 'newGroups') {
					this.formGroup.controls.client.disable();
				}
			});
	}
	dataTranslate() {
		this.subscriptionTranslate = this.translate.init('AccessControl').subscribe((data) => {
			this.translateModal = data.pages.groups.modalGroups;
		});
	}

	ngAfterContentChecked(): void {
		this.changeDetector.detectChanges();
	}
	ngOnDestroy(): void {
		this.subscriptionClient?.unsubscribe();
		this.subscriptionTranslate?.unsubscribe();
	}
}
